<template>
    <div v-if="exportaciones.length" class="exportaciones-en-curso" :class="{ 'con-chatbot': conChatbot }">
        <v-card v-for="exportacion in exportaciones" :key="exportacion.url" class="pa-3 mt-2" elevation="6">
            <p class="text-caption mb-2">Generando archivo: <strong>{{ exportacion.title }}</strong></p>
            <v-progress-linear indeterminate rounded height="6" color="primary"></v-progress-linear>
        </v-card>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Aviso fijo abajo a la derecha con las planillas que se están generando,
// visible desde cualquier vista de la aplicación.
export default {
    props: {
        // El botón del chatbot ocupa la esquina; el aviso se corre a su izquierda.
        conChatbot: { type: Boolean, default: false },
    },
    computed: {
        ...mapState("exportaciones", ["enCurso"]),
        exportaciones() {
            return Object.keys(this.enCurso).map((url) => ({ url, title: this.enCurso[url].title }));
        },
    },
};
</script>

<style>
.exportaciones-en-curso {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 3;
    width: 300px;
    max-width: calc(100vw - 32px);
}

.exportaciones-en-curso.con-chatbot {
    right: 96px;
}
</style>
